<p-calendar [(ngModel)]="inputDate"
            [styleClass]="styleClass"
            [inputStyleClass]="inputStyleClass"
            [readonlyInput]="true"
            [monthNavigator]="true"
            [yearNavigator]="true"
            [yearRange]="getYearRange()"
            dateFormat="MM d"
            (onSelect)="emitOutput()">
</p-calendar>
